import { DateRangeQueryParams } from '@sonar-software/sonar-ts-types';
import { LegacyTimelineSummary } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type GetLegacyTimelineSummaryRequest = DateRangeQueryParams & {
	changeTypeFilters?: Array<string>;
	lastModifiedByUsernameFilters?: Array<string>;
	objectTypeFilters?: Array<string>;
	search?: string;
	system: boolean;
	tzoffset: number;
};

export const getLegacyTimelineSummary = createGetEndpoint<GetLegacyTimelineSummaryRequest, LegacyTimelineSummary>(
	(request) => `/api/v2/Timelines/summary?${getQueryString(request)}`
);
